import {TAB_TYPE} from "../model/user.model";
import {MEMBER_TYPE} from "../../setting/common/service/employer-account/member/member.service";

export const ROLE_BASE_ACCESS_SUB_COLLECTION: string = 'role__tab_access';

export const ALL_VISIBLE_TABS: TAB_TYPE[] = [
    TAB_TYPE.DASHBOARD,
    TAB_TYPE.JOB_POSTS,
    TAB_TYPE.DRIVES,
    TAB_TYPE.CHALLENGES,
    TAB_TYPE.APPLICANTS,
    TAB_TYPE.TALENT_POOL,
    TAB_TYPE.FORMS,
    TAB_TYPE.CONNECTIONS,
    TAB_TYPE.REPORTS,
    TAB_TYPE.INBOX,
    TAB_TYPE.SETTINGS
];

export const VISIBLE_TABS_WITHOUT_SETTINGS: TAB_TYPE[] =
    ALL_VISIBLE_TABS.filter(tabType => tabType !== TAB_TYPE.SETTINGS);

export const EXTERNAL_VISIBLE_TABS: TAB_TYPE[] = [
    TAB_TYPE.DASHBOARD,
    TAB_TYPE.JOB_POSTS,
    TAB_TYPE.CHALLENGES,
    TAB_TYPE.INBOX
];

export const FALLBACK_VISIBLE_TABS: TAB_TYPE[] = [
    TAB_TYPE.DASHBOARD,
    TAB_TYPE.INBOX
];

export const DEFAULT_VISIBLE_TABS_BY_MEMBER_TYPE: Record<MEMBER_TYPE, TAB_TYPE[]> = {
    [MEMBER_TYPE.OWNER]: ALL_VISIBLE_TABS,
    [MEMBER_TYPE.ADMIN]: VISIBLE_TABS_WITHOUT_SETTINGS,
    [MEMBER_TYPE.MEMBER]: VISIBLE_TABS_WITHOUT_SETTINGS,
    [MEMBER_TYPE.EXTERNAL]: EXTERNAL_VISIBLE_TABS
};
